import React, { useState } from 'react';
import { Turl } from '../components/tUrl.js';
import '../css/emailVerificationFlow.css';
import { t } from 'ttag';
import { formatNumberWithCommas } from '../components/formatIntegerWithCommas.js';

const tg = window.Telegram ? window.Telegram.WebApp : null;

// --- API Функции (адаптированы) ---
// (Бывшая sendTradeCode)
const sendLicenseCode = async (licenseId, amount) => {
    const _userData = tg ? tg.initData : null;
    let userData = {
        initData: _userData,
        amount: amount,
        licenseId: licenseId,
        type: 5 // 
    };

    const response = await fetch(Turl + '/st/send-trade-code', { 
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(userData),
    });
    return response.json();
};

// (Бывшая submitTradeDeposit)
const submitLicensePurchase = async (licenseId, amount, code) => {
    const _userData = tg ? tg.initData : null;
    let userData = {
        initData: _userData,
        code: code,
        amount: parseFloat(amount),
        licenseId: licenseId
    };

    const response = await fetch(Turl + '/st/license-buy-points', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify(userData),
    });
    return response.json();
};

// --- Компонент ---

const BuyLicPoints = ({ recData }) => {
    const [step, setStep] = useState('select_license'); // 'select_license', 'enter_code', 'confirmed'

    const [selectedLicense, setSelectedLicense] = useState(null);

    const [code, setCode] = useState('');
    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState('');

    const handleLicenseSelect = async (license) => {
        setIsLoading(true);
        setError('');
        setSelectedLicense(license); // Сохраняем выбранную лицензию

        const response = await sendLicenseCode(license.id, license.pricep);

        setIsLoading(false);
        if (response.success) {
            setStep('enter_code'); // Переходим к шагу ввода кода
        } else {
            setError(response.message || t`Failed to send code. Please try again.`);
            setSelectedLicense(null); // Сбрасываем выбор в случае ошибки
        }
    };

    const handleCodeSubmit = async (e) => {
        e.preventDefault();
        setIsLoading(true);
        setError('');

        const response = await submitLicensePurchase(
            selectedLicense.id,
            selectedLicense.pricep,
            code
        );

        setIsLoading(false);
        if (response.success) {
            setStep('confirmed');
            setTimeout(() => {
                window.location.reload();
            }, 1000);
        } else {
            setError(response.message || t`Error. Invalid code.`);
        }
    };

    // --- Рендеринг в зависимости от текущего шага ---

    if (step === 'confirmed') {
        return (
            <div className="Email-block">
                <div>
                    <h2 style={{ color: '#4cdf4c' }}>✓ {t`Successfully!`}</h2>
                    <p>{t`Your`} <strong>{selectedLicense.name}</strong> {t`license purchase for`} <strong>{selectedLicense.pricep} points</strong> {t`is successful.`}</p>
                </div>
            </div>
        );
    }

    if (step === 'enter_code') {
        return (
            <div className="Email-block">
                <h2>{t`Email Confirmation`}</h2>
                <p>
                   {t`We sent a code to your registered email.`}<br />
                    {t`You are purchasing:`} <strong>{selectedLicense.name}</strong> {t`for`} <strong>{selectedLicense.pricep} points</strong>.
                </p>
                <form onSubmit={handleCodeSubmit}>
                    <div className='email-enter'>
                        <label htmlFor="code">{t`Verification code:`}</label>
                        <input
                            type="text"
                            id="code"
                            value={code}
                            onChange={(e) => setCode(e.target.value)}
                            placeholder="123456"
                            required
                            disabled={isLoading}
                        />
                    </div>
                    <div className='email-enter'>
                        <button type="submit" disabled={isLoading || code.length < 6}>
                            {isLoading ? t`Checking...` : t`Confirm & Buy`}
                        </button>
                    </div>
                    {error && <p className="error-text">{error}</p>}
                    <button
                        type="button"
                        onClick={() => { setStep('select_license'); setError(''); setSelectedLicense(null); }}
                        className="link-button"
                    >
                        {t`Change license`}
                    </button>
                </form>
            </div>
        );
    }

    // --- Шаг 1: Выбор лицензии (Бывший 'enter_amount') ---
    return (
        <>
            {/* Блок Баланса */}
            <div className="f-balance-card">
                <div className="f-balance-label">{t`Points balance`}</div>
                <div className="f-balance-value">{formatNumberWithCommas(parseFloat(recData.lic_ref_point), 4)} {t`points`}</div>
            </div>

            <div className="Email-block">
                <h2>{t`Select a license to purchase`}</h2>
                <p>{t`We will send a confirmation code to your email.`}</p>

                <div className="license-selection">
                    {recData.lic_type && recData.lic_type.map(lic => {
                        const hasEnoughBalance = recData.lic_ref_point >= lic.pricep;
                        return (
                            <button
                                key={lic.id}
                                className="license-option-button"
                                onClick={() => handleLicenseSelect(lic)}
                                disabled={isLoading || !hasEnoughBalance}
                            >
                                <span className="license-name">{lic.name}</span>
                                <span className="license-price">{lic.pricep} points</span>
                                {!hasEnoughBalance && <span className="license-error"> ({t`Not enough funds`})</span>}
                            </button>
                        );
                    })}
                </div>

                {error && <p className="error-text" style={{ marginTop: '15px' }}>{error}</p>}

                {isLoading && selectedLicense && (
                    <div className='email-enter'>
                        <p>{t`Sending code for`} {selectedLicense.name}...</p>
                    </div>
                )}
            </div>
        </>
    );
};

export { BuyLicPoints };